export default __webpack_public_path__ + "static/media/bag3.0326a288.webp";